import DepartmentsAdmin from "../../crm/crmAdmin/departments/DepartmentAdmin";

export default function Departments() {
    return (
        <DepartmentsAdmin />
    )
}
